module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_asakusa-6dcc50f787c8cd7d617d8663194ffe38.jpg";